import React from 'react';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { IUserStore, IAuthStore } from '@src/models';
import { Flex, Text, Link } from 'src/kit';
import { Dropdown } from 'src/components';
import { Avatar } from '../../molecules/Avatar';
import { CompanyActions } from './components/CompanyActions';
import { AuthActions } from './components/AuthActions';

type DesktopHeaderProps = {
  authStore: IAuthStore;
  userStore: IUserStore;
  title?: string;
  renderTitle?: () => React.ReactNode;
  search?: null | React.ReactNode;
};
export const DesktopHeader = observer(function DesktopHeader({
  title,
  authStore,
  userStore,
  renderTitle,
  search = null
}: DesktopHeaderProps) {
  const { isAuthorized, logout } = authStore;
  const { user, defaultProfileRoute, isUserActive } = userStore;

  React.useEffect(() => {
    const prevTitle = window.document.title;

    if (title) {
      window.document.title = `${title} | Sainoo`;
    }
    return () => {
      window.document.title = prevTitle;
    };
  }, [title]);

  return (
    <>
      {renderTitle
        ? renderTitle()
        : title && (
            <Text data-testid="header-title" fontWeight="semiBold" flex="0 1 286px" fontSize={20} textStyle="nowrap">
              {title}
            </Text>
          )}
      {search}
      <Wrapper ml="auto" alignItems="center">
        {user?.company && <CompanyActions user={user} isUserActive={isUserActive} />}
        {/* {isFreelancer && <FreelancerActions />} */}
        {!isAuthorized ? (
          <AuthActions />
        ) : (
          <Dropdown>
            <Dropdown.Toggle py={5}>
              <Avatar
                src={user?.photo_thumbnail_url}
                alt="photo"
                firstName={user?.first_name}
                size={40}
                color="header.text"
                bg="paleGreyTwo"
                fontSize="22px"
                fontWeight="normal"
                lineHeight="38px"
              />
            </Dropdown.Toggle>
            <Dropdown.Menu mt={'-10px'} minWidth={150} color="textSecondary">
              <Dropdown.Item>
                <Link to={defaultProfileRoute}>My profile</Link>
              </Dropdown.Item>
              <Dropdown.Item onClick={() => logout()}>
                <Text>Logout</Text>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}
      </Wrapper>
    </>
  );
});

const Wrapper = styled(Flex)`
  li:first-child {
    padding: 0;
    a {
      padding: 4px 12px;
      width: 100%;
    }
  }
`;
